import script from "./UpCargCaman.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpCargCaman.vue?vue&type=script&lang=ts&setup=true"

import "./UpCargCaman.vue?vue&type=style&index=0&id=71780570&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71780570"]])

export default __exports__